import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import {
  CertificationInputField,
  CertificationSelectField,
  CertificationTextareaField,
} from "@modules/certificaciones/shared/ui";

type BaseProps = {
  label: string;
  hint?: string;
  fullWidth?: boolean;
};

type InputProps = BaseProps & InputHTMLAttributes<HTMLInputElement>;
type TextareaProps = BaseProps & TextareaHTMLAttributes<HTMLTextAreaElement>;
type SelectProps = BaseProps & SelectHTMLAttributes<HTMLSelectElement>;

export function Iso2700127701InputField({
  label,
  hint,
  fullWidth = false,
  className = "",
  ...props
}: InputProps) {
  return (
    <CertificationInputField
      label={label}
      hint={hint}
      fullWidth={fullWidth}
      wrapperClassName={className}
      {...props}
    />
  );
}

export function Iso2700127701TextareaField({
  label,
  hint,
  fullWidth = false,
  className = "",
  ...props
}: TextareaProps) {
  return (
    <CertificationTextareaField
      label={label}
      hint={hint}
      fullWidth={fullWidth}
      wrapperClassName={className}
      {...props}
    />
  );
}

export function Iso2700127701SelectField({
  label,
  hint,
  fullWidth = false,
  className = "",
  children,
  ...props
}: SelectProps) {
  return (
    <CertificationSelectField
      label={label}
      hint={hint}
      fullWidth={fullWidth}
      wrapperClassName={className}
      {...props}
    >
      {children}
    </CertificationSelectField>
  );
}
